// Relojes con desfase; los valores coinciden con DesfaseReloj.CONTEXTOS
export const CONTEXTO_RELOJ_PRODUCCION = 10;
export const CONTEXTO_RELOJ_BODEGA = 20;

export const NOMBRES_RELOJ = {
    [CONTEXTO_RELOJ_PRODUCCION]: "Reloj de producción",
    [CONTEXTO_RELOJ_BODEGA]: "Reloj de bodega",
};

export const DESCRIPCIONES_RELOJ = {
    [CONTEXTO_RELOJ_PRODUCCION]:
        "Fecha y hora con la que se registran los movimientos del turno de " +
        "producción y la recepción de pallets en bodega.",
    [CONTEXTO_RELOJ_BODEGA]:
        "Fecha y hora con la que se registran las salidas y los traslados de " +
        "control de calidad de bodega. El cierre de inventario no la usa: su " +
        "fecha de corte se indica en el cierre.",
};
